import { Node } from "@tiptap/core";
import { Plugin, PluginKey } from "prosemirror-state";

export const OneLiner = Node.create({
	name: "one-liner",
	topNode: true,
	content: "block",
	addProseMirrorPlugins() {
		return [
			new Plugin({
				key: new PluginKey("eventHandler"),
				props: {
					// Overrides enter to create a new line
					handleKeyDown: (_, event) => {
						if (event.key === "Enter" && !event.shiftKey) {
							return true;
						}
					},
				},
			}),
		];
	},
});
